class SelectFormElementController {
  constructor() {

  }

  $onInit() {
    if(!this.value){
      this.value = this.options[0].id;
    }
  }
}

export default SelectFormElementController;
